import header from './components/header/header.vue'
import footer from './components/footer/footer.vue'

export default{
    install(Vue){
        Vue.component('header-main',header)
        Vue.component('footer-main',footer)
    }
}

export{header,footer}


// WEBPACK FOOTER //
// ./src/main_components.js